// src/pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getIdTokenResult, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import '../styles/login.css';
import Seo from '../components/Seo';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setLoading(true);

    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const tokenResult = await getIdTokenResult(cred.user, true);

      if (tokenResult?.claims?.isAdmin !== true) {
        await signOut(auth);
        setErrorMsg('Akun ini tidak memiliki akses admin.');
        setLoading(false);
        return;
      }

      navigate('/admin'); // redirect to admin dashboard
    } catch (error) {
      setErrorMsg("Login gagal: email atau password salah.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Seo title="Login Admin" description="Halaman login admin ruqyah syar'i." canonical="/login" noindex />
      <form className="login-form" onSubmit={handleLogin}>
        <h2 className="mb-3">Login Admin</h2>

        {errorMsg && <p className="error-msg">{errorMsg}</p>}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          disabled={loading}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          disabled={loading}
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Memproses...' : 'Login'}
        </button>
      </form>
    </div>
  );
}
